const formatLineToHtmlBreak = (text: string): string => {
  if (text.includes('\n')) {
    return text.replace(/\n/g, '<br />');
  }
  return text;
};

export { formatLineToHtmlBreak };
